// extracted by mini-css-extract-plugin
export var wrapper = "VideoDetails-module_wrapper__2ek0l";
export var videoTitle = "VideoDetails-module_videoTitle__3ZF1X";
export var details = "VideoDetails-module_details__3cg5J";
export var divider = "VideoDetails-module_divider__3OwKm";
export var link = "VideoDetails-module_link__dBdQ6";
export var buttonWrapper = "VideoDetails-module_buttonWrapper__1xOO_";